/* Homepage V4: buy one Sweat Defender Crew.
   Color tiles (single pick), size row, one Add to cart. The gallery follows
   the picked color and opens on config.startPhoto (2 = the model shot).
   Desktop thumbnails live in a column capped at the main photo's height and
   scroll with the arrow buttons; phones keep the horizontal strip.
   Bundle panel: title, thumbnail and both links follow the picked color and
   size; the links carry ?add=<variant id> (plus &goal=<n> when a goal is set) for the bundle page.
   Since 2026-11-03 the panel is one Build a Bundle button with a line under it. */
(function () {
  'use strict';
  if (window.customElements.get('v4-buy')) return;

  var fmtCache = {};
  function money(amount, currency) {
    var key = currency || 'USD';
    if (!fmtCache[key]) {
      try { fmtCache[key] = new Intl.NumberFormat('en-US', { style: 'currency', currency: key }); }
      catch (e) { fmtCache[key] = { format: function (n) { return '$' + Number(n).toFixed(2); } }; }
    }
    return fmtCache[key].format(amount);
  }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }

  function V4Buy() { return Reflect.construct(HTMLElement, [], V4Buy); }
  V4Buy.prototype = Object.create(HTMLElement.prototype);
  V4Buy.prototype.constructor = V4Buy;

  V4Buy.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    var self = this;
    try {
      this.config = JSON.parse(this.querySelector('[data-v4y-config]').textContent);
      this.products = JSON.parse(this.querySelector('[data-v4y-products]').textContent);
    } catch (e) { console.error('[v4-buy] bad JSON', e); return; }
    this.text = this.config.text || {};
    this.routes = this.config.routes || {};
    this.currency = this.config.currency || 'USD';
    this.sizes = (this.config.sizes || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
    this.size = this.sizes.indexOf(this.config.defaultSize) >= 0 ? this.config.defaultSize : this.sizes[0];
    this.byId = {};
    this.products.forEach(function (p) { p.vBySize = {}; p.variants.forEach(function (v) { p.vBySize[v.size] = v; }); self.byId[p.id] = p; });
    var first = this.byId[this.config.defaultColor] || this.products.filter(function (p) { return p.available; })[0] || this.products[0];
    this.color = first ? first.id : null;

    var $ = function (sel) { return self.querySelector(sel); };
    this.$main = $('[data-v4y-main]'); this.$thumbs = $('[data-v4y-thumbs]'); this.$up = $('[data-v4y-up]'); this.$down = $('[data-v4y-down]');
    this.$price = $('[data-v4y-price]'); this.$compare = $('[data-v4y-compare]'); this.$colorname = $('[data-v4y-colorname]');
    this.$grid = $('[data-v4y-grid]'); this.$sizes = $('[data-v4y-sizes]'); this.$add = $('[data-v4y-add]'); this.$toast = $('[data-v4y-toast]');
    this.bundle = this.config.bundle || {};
    this.$btitle = $('[data-v4y-btitle]'); this.$bthumb = $('[data-v4y-bthumb]'); this.$blinks = Array.prototype.slice.call(this.querySelectorAll('[data-v4y-blink]'));

    this.buildGrid(); this.buildSizes();
    if (this.$up) this.$up.addEventListener('click', function () { self.scrollThumbs(-1); });
    if (this.$down) this.$down.addEventListener('click', function () { self.scrollThumbs(1); });
    if (this.$thumbs) {
      this.$thumbs.addEventListener('scroll', function () { self.updateArrows(); }, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(function () { self.updateArrows(); }).observe(this.$thumbs);
    }
    this.$add.addEventListener('click', function () { self.addToCart(); });
    this.$qty = $('[data-v4y-qty]');
    if (this.$qty) {
      $('[data-v4y-minus]').addEventListener('click', function () { self.setQty(self.qty() - 1); });
      $('[data-v4y-plus]').addEventListener('click', function () { self.setQty(self.qty() + 1); });
      this.$qty.addEventListener('change', function () { self.setQty(self.qty()); });
    }
    this.$chart = $('[data-v4y-chart]');
    if (this.$chart) this.initChart();
    this.setColor(this.color, true);
  };

  /* ---------- size chart pop-up ---------- */
  var SIZE_SHORT = { 'small': 'S', 'medium': 'M', 'large': 'L', 'x-large': 'XL', 'xx-large': 'XXL', 'xxx-large': 'XXXL', 'xxxx-large': 'XXXXL' };
  var GROUP_SHORT = { 'measure yourself': 'You', 'garment measurements': 'The shirt' };
  function cellText(c) { return (c.textContent || '').replace(/\s+/g, ' ').trim(); }
  function shortLabel(t) { return t.replace(/^(your|shirt|front)\s+/i, '').replace(/\s+length$/i, '') || t; }
  function cleanValue(t) { return t.replace(/["”″]/g, '').replace(/(\d)\s*-\s*(\d)/g, '$1–$2'); }
  V4Buy.prototype.initChart = function () {
    var self = this, d = this.$chart;
    Array.prototype.forEach.call(this.querySelectorAll('[data-v4y-chart-open]'), function (b) { b.addEventListener('click', function () { self.openChart(); }); });
    d.querySelector('[data-v4y-chart-close]').addEventListener('click', function () { self.closeChart(); });
    d.addEventListener('click', function (e) { if (e.target === d) self.closeChart(); });
    d.addEventListener('close', function () { document.documentElement.classList.remove('v4-chart-open'); });
    // Esc closes a modal dialog at once; route it through closeChart so it slides down like the other ways out
    d.addEventListener('cancel', function (e) { e.preventDefault(); self.closeChart(); });
    Array.prototype.forEach.call(d.querySelectorAll('[data-v4y-unit]'), function (b) { b.addEventListener('click', function () { self.setUnit(b.getAttribute('data-v4y-unit')); }); });
  };
  V4Buy.prototype.buildChart = function () {
    var d = this.$chart, src = d.querySelector('[data-v4y-chart-src]'), body = d.querySelector('[data-v4y-chart-body]');
    var root = src.content || src, tables = root.querySelectorAll('table'), units = [];
    var html = '';
    Array.prototype.forEach.call(tables, function (t, ti) {
      var unit = (t.getAttribute('data-type') || (ti === 0 ? 'in' : 'cm')).toLowerCase();
      var rows = Array.prototype.slice.call(t.querySelectorAll('tr')), head = '', bodyRows = '', inBody = false;
      rows.forEach(function (r) {
        var cells = Array.prototype.slice.call(r.children), first = cells[0] ? cellText(cells[0]).toLowerCase() : '';
        if (!inBody) {
          var isLabels = first === 'size';
          head += '<tr>' + cells.map(function (c) {
            var txt = cellText(c), span = c.getAttribute('colspan');
            if (!isLabels) txt = GROUP_SHORT[txt.toLowerCase()] || txt;
            else if (txt.toLowerCase() !== 'size') txt = shortLabel(txt);
            return '<th' + (isLabels ? '' : ' class="is-group"') + (span ? ' colspan="' + span + '"' : '') + '>' + txt + '</th>';
          }).join('') + '</tr>';
          if (isLabels) inBody = true;
          return;
        }
        bodyRows += '<tr>' + cells.map(function (c, i) {
          var txt = cellText(c);
          return '<td>' + (i === 0 ? (SIZE_SHORT[txt.toLowerCase()] || txt) : cleanValue(txt)) + '</td>';
        }).join('') + '</tr>';
      });
      if (!bodyRows) return;
      units.push(unit);
      html += '<table data-unit="' + unit + '"' + (units.length > 1 ? ' hidden' : '') + '><thead>' + head + '</thead><tbody>' + bodyRows + '</tbody></table>';
    });
    if (!units.length) {
      // no table on the page: show the page as written
      body.innerHTML = src.innerHTML; body.classList.add('is-raw');
      d.querySelector('[data-v4y-units]').hidden = true;
      var note = d.querySelector('[data-v4y-chart-note]'); if (note) note.hidden = true;
      return;
    }
    var img = root.querySelector('img'), callout = root.querySelector('.size-chart-callout');
    if (img || callout) {
      html += '<div class="v4-chart__guide' + (img && callout ? '' : ' is-solo') + '">' +
        (img ? '<img src="' + img.getAttribute('src') + '" alt="' + (img.getAttribute('alt') || '').replace(/"/g, '&quot;') + '" width="92" height="93">' : '') +
        (callout ? '<div class="v4-chart__callout">' + Array.prototype.map.call(callout.querySelectorAll('p'), function (p) { return '<p>' + p.innerHTML + '</p>'; }).join('') + '</div>' : '') + '</div>';
    }
    body.innerHTML = html;
    this.chartUnits = units;
    var unitBox = d.querySelector('[data-v4y-units]');
    if (units.length < 2) unitBox.hidden = true;
    else Array.prototype.forEach.call(unitBox.querySelectorAll('[data-v4y-unit]'), function (b) { b.hidden = units.indexOf(b.getAttribute('data-v4y-unit')) < 0; });
    this.setUnit(units[0]);
  };
  V4Buy.prototype.setUnit = function (u) {
    var d = this.$chart;
    Array.prototype.forEach.call(d.querySelectorAll('[data-v4y-chart-body] table'), function (t) { t.hidden = t.getAttribute('data-unit') !== u; });
    Array.prototype.forEach.call(d.querySelectorAll('[data-v4y-unit]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v4y-unit') === u ? 'true' : 'false'); });
  };
  V4Buy.prototype.openChart = function () {
    var d = this.$chart;
    if (this._closing) { this._closing = false; clearTimeout(this._closeTimer); d.classList.remove('is-closing'); }
    if (!this._chartBuilt) { this._chartBuilt = true; this.buildChart(); }
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    document.documentElement.classList.add('v4-chart-open');
  };
  // plays the slide-down (.is-closing), then closes; a timer backs up animationend so the sheet can never stay stuck open
  V4Buy.prototype.closeChart = function () {
    var self = this, d = this.$chart;
    if (!d.hasAttribute('open') || this._closing) return;
    var done = function () {
      if (!self._closing) return;
      self._closing = false; clearTimeout(self._closeTimer);
      d.classList.remove('is-closing');
      if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
      document.documentElement.classList.remove('v4-chart-open');
    };
    this._closing = true;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { done(); return; }
    d.classList.add('is-closing');
    d.querySelector('.v4-chart__sheet').addEventListener('animationend', done, { once: true });
    this._closeTimer = setTimeout(done, 350);
  };

  /* ---------- gallery ---------- */
  V4Buy.prototype.setGallery = function (p) {
    var self = this;
    if (!this.$thumbs || !p) return;
    this.$thumbs.innerHTML = '';
    var g = p.gallery && p.gallery.length ? p.gallery : [[p.color, p.image, p.image, p.image, p.image]];
    var start = Math.min(Math.max((parseInt(this.config.startPhoto, 10) || 1) - 1, 0), g.length - 1);
    g.forEach(function (item, i) {
      var b = el('button', 'v4-gallery__thumb' + (i === start ? ' is-on' : ''));
      b.type = 'button'; b.dataset.full = item[1]; b.dataset.full2x = item[2]; b.dataset.alt = item[0] || '';
      b.setAttribute('aria-label', item[0] || ('Photo ' + (i + 1)));
      var img = el('img'); img.src = item[3]; img.srcset = item[3] + ' 1x, ' + item[4] + ' 2x'; img.alt = ''; img.loading = 'lazy'; img.width = 50; img.height = 63;
      b.appendChild(img);
      b.addEventListener('click', function () { self.showPhoto(b); });
      self.$thumbs.appendChild(b);
    });
    this.showPhoto(this.$thumbs.children[start], true);
    this.$thumbs.scrollTop = 0; this.$thumbs.scrollLeft = 0;
    this.updateArrows();
  };
  V4Buy.prototype.showPhoto = function (thumb, quiet) {
    if (!this.$main || !thumb) return;
    this.$main.src = thumb.dataset.full;
    this.$main.srcset = thumb.dataset.full2x ? thumb.dataset.full + ' 900w, ' + thumb.dataset.full2x + ' 1400w' : '';
    this.$main.alt = thumb.dataset.alt || '';
    Array.prototype.forEach.call(this.$thumbs.children, function (t) { t.classList.toggle('is-on', t === thumb); });
    if (!quiet) { try { thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {} }
  };
  V4Buy.prototype.scrollThumbs = function (dir) {
    var t = this.$thumbs; if (!t) return;
    var step = t.clientHeight * 0.8;
    try { t.scrollBy({ top: dir * step, behavior: 'smooth' }); } catch (e) { t.scrollTop += dir * step; }
  };
  V4Buy.prototype.updateArrows = function () {
    var t = this.$thumbs; if (!t || !this.$up) return;
    var vertical = t.scrollHeight > t.clientHeight + 2;
    var canUp = vertical && t.scrollTop > 2;
    var canDown = vertical && t.scrollTop + t.clientHeight < t.scrollHeight - 2;
    this.$up.hidden = !canUp; this.$down.hidden = !canDown;
  };

  /* ---------- build ---------- */
  V4Buy.prototype.buildGrid = function () {
    var self = this;
    this.$grid.innerHTML = '';
    this.products.forEach(function (p) {
      var t = el('button', 'v4-tile'); t.type = 'button'; t.dataset.cid = p.id; t.setAttribute('role', 'radio'); t.setAttribute('aria-label', p.color);
      var img = el('img', 'v4-tile__img'); img.src = p.image || ''; img.alt = ''; img.loading = 'lazy'; img.width = 64; img.height = 64;
      t.append(img, el('span', 'v4-tile__soldout', ''), el('span', 'v4-tile__name', p.color));
      t.addEventListener('click', function () { self.setColor(p.id); });
      self.$grid.appendChild(t);
    });
  };
  V4Buy.prototype.buildSizes = function () {
    var self = this;
    this.$sizes.innerHTML = '';
    this.sizes.forEach(function (s) {
      var b = el('button', 'v4-size', s); b.type = 'button'; b.dataset.size = s; b.setAttribute('role', 'radio');
      b.addEventListener('click', function () { if (!b.classList.contains('is-off')) { self.size = s; self.render(); } });
      self.$sizes.appendChild(b);
    });
  };
  /* bundle panel: "Your Black + 2 more", their shirt in the first slot, links carry the shirt and the goal */
  V4Buy.prototype.renderBundle = function (p, v) {
    if (!p) return;
    var goal = parseInt(this.bundle.goal, 10) || 0, more = Math.max(goal - 1, 1);
    if (this.$btitle && this.bundle.title) this.$btitle.textContent = this.bundle.title.replace('{color}', p.color).replace('{count}', more);
    if (this.$bthumb && p.image && this.$bthumb.getAttribute('src') !== p.image) { this.$bthumb.src = p.image; this.$bthumb.alt = p.color; }
    var base = this.bundle.link || '';
    if (!base) return;
    // ?add=<variant> puts the picked shirt in the bundle; goal only for the old Pick 2 more panel (0 = none)
    var params = [];
    if (v && v.available) params.push('add=' + v.id);
    if (goal > 1) params.push('goal=' + goal);
    var href = params.length ? base + (base.indexOf('?') >= 0 ? '&' : '?') + params.join('&') : base;
    this.$blinks.forEach(function (a) { a.setAttribute('href', href); });
  };

  /* ---------- state ---------- */
  V4Buy.prototype.setColor = function (cid, first) {
    var p = this.byId[cid]; if (!p) return;
    if (this.color !== cid || first) { this.color = cid; this.setGallery(p); }
    // keep the size if this color has it; otherwise the first size in stock
    if (!(p.vBySize[this.size] && p.vBySize[this.size].available)) {
      var inStock = this.sizes.filter(function (s) { return p.vBySize[s] && p.vBySize[s].available; })[0];
      if (inStock) this.size = inStock;
    }
    this.render();
  };
  V4Buy.prototype.render = function () {
    var self = this, p = this.byId[this.color], v = p ? p.vBySize[this.size] : null;
    Array.prototype.forEach.call(this.$grid.children, function (t) {
      var q = self.byId[t.dataset.cid], on = t.dataset.cid === self.color;
      t.classList.toggle('is-sel', on); t.classList.toggle('is-off', !q.available);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.querySelector('.v4-tile__soldout').textContent = q.available ? '' : self.text.soldOut;
    });
    if (this.$colorname) this.$colorname.textContent = p ? p.color : '';
    Array.prototype.forEach.call(this.$sizes.children, function (b) {
      var s = b.dataset.size, sv = p ? p.vBySize[s] : null, ok = !!(sv && sv.available);
      b.classList.toggle('is-on', s === self.size); b.classList.toggle('is-off', !ok);
      b.setAttribute('aria-checked', s === self.size ? 'true' : 'false'); b.disabled = !ok;
    });
    var price = v ? v.price / 100 : (p && p.variants[0] ? p.variants[0].price / 100 : 0);
    var compare = v && v.compare ? v.compare / 100 : 0;
    this.$price.textContent = money(price, this.currency);
    if (compare > price) { this.$compare.textContent = money(compare, this.currency); this.$compare.hidden = false; } else this.$compare.hidden = true;
    this.renderBundle(p, v);
    var canBuy = !!(v && v.available);
    if (!this.busy) this.$add.textContent = canBuy ? this.text.button : this.text.buttonSoldOut;
    this.$add.disabled = !canBuy;
  };

  /* ---------- quantity ---------- */
  V4Buy.prototype.qty = function () { var n = this.$qty ? parseInt(this.$qty.value, 10) : 1; return n > 0 ? n : 1; };
  V4Buy.prototype.setQty = function (n) { if (this.$qty) this.$qty.value = Math.max(1, Math.min(99, n || 1)); };

  /* ---------- cart ---------- */
  V4Buy.prototype.addToCart = function () {
    var self = this, p = this.byId[this.color], v = p ? p.vBySize[this.size] : null;
    if (!v || !v.available || this.busy) return;
    this.busy = true;
    this.$add.textContent = this.text.buttonAdding || this.text.button;
    this.$add.classList.add('is-busy');
    fetch((this.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: this.qty() }] }) })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (data) { if (!res.ok) throw new Error(data.description || data.message || self.text.cartError); return data; }); })
      .then(function () {
        if (typeof window.detectBundleDiscounts !== 'function') return;
        return Promise.race([Promise.resolve(window.detectBundleDiscounts()).catch(function () {}), new Promise(function (r) { setTimeout(r, 4000); })]);
      })
      .then(function () {
        if (self.$qty) self.$qty.value = 1;
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.onCartDrawerUpdate === 'function') { drawer.onCartDrawerUpdate(); drawer.open(); }
        else window.location.href = self.routes.cart || '/cart';
      })
      .catch(function (e) { console.error('[v4-buy] add failed', e); self.toast(e && e.message ? e.message : self.text.cartError); })
      .then(function () { self.busy = false; self.$add.classList.remove('is-busy'); self.render(); });
  };
  V4Buy.prototype.toast = function (msg) {
    var self = this;
    if (!msg) return;
    this.$toast.textContent = msg; this.$toast.hidden = false;
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(function () { self.$toast.hidden = true; }, 2600);
  };

  customElements.define('v4-buy', V4Buy);
})();
